import { combineReducers } from 'redux';
import mainReducer from '@gcloud-npm/next12.app-controller.reducers-sagas.main-reducer-n';
import modalsReducer from '@gcloud-npm/next12.app-controller.reducers-sagas.modals-reducer';
import custoReducer from '@gcloud-npm/next12.app-controller.reducers-sagas.custo-reducer';
import constantsReducer from './constants';

const REDUCERS_LIST = {
  main: mainReducer,
  constants: constantsReducer,
  modals: modalsReducer,
  custo: custoReducer,
};

const rootReducers = () =>
  combineReducers({
    ...REDUCERS_LIST,
  });

export default rootReducers;
